import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { MultiSelect } from '@/components/forms/MultiSelect'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { FormField } from '@/components/forms/FormField'
import { setFilter } from '@/reducers/realtime/realtimeCoaching/realtimeCoaching.redux'
import { fetchTagsByOrg } from '@/reducers/realtime/realtimeCoaching/realtimeCoaching.actions'

export const TagsDropdown = ({ disabledByAgents = false }) => {
  const dispatch = useDispatch()
  const { organizationid: organizationId } = useSelector((state) => state.currentUser)
  const { data, filters, loading } = useSelector((state) => state.realtimeCoaching)
  const isDropdownDisabled = disabledByAgents && !isEmpty(filters.agents)

  useEffect(() => {
    if (isEmpty(data.tags)) {
      dispatch(fetchTagsByOrg(organizationId))
    }
  }, [])

  return (
    <FormField data-testid="rtc-tags-dropdown">
      <label htmlFor="rtc-filter-tags">Tags</label>
      <InteractiveTooltip
        block
        content="Agents and tags cannot be selected at the same time"
        hide={!isDropdownDisabled}
      >
        <div>
          <MultiSelect
            placeholderPill="All Tags"
            inputId="rtc-filter-tags"
            options={data.tags}
            loading={loading.tags}
            value={filters.tags}
            onChange={(value) => dispatch(setFilter({ tags: value }))}
            disabled={isDropdownDisabled}
          />
        </div>
      </InteractiveTooltip>
    </FormField>
  )
}
